import { Directive, ElementRef, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputPassword]'
})
export class AppInputPasswordDirective {

  shown = false;

  constructor(@Self() private ngControl: NgControl, private element: ElementRef) {
  }
  ngOnInit(): void {
    this.setup();
  }

  setup(): void {
    const parent = this.element.nativeElement.parentNode;
    const divParent = document.createElement('div');
    divParent.className = 'input-group-append';
    const span = document.createElement('span');
    span.className = 'input-group-text';
    span.innerHTML = '<i class="fa fa-eye-slash"></i>';
    span.addEventListener('click', () => {
     this.toggle(span);
    });
    divParent.appendChild(span);
    parent.appendChild(divParent);
  }

  toggle(span: HTMLElement): void {
    this.shown = !this.shown;
    if (this.shown) {
      this.element.nativeElement.setAttribute('type', 'text');
      span.innerHTML = '<i class="fa fa-eye"></i>';
    } else {
      this.element.nativeElement.setAttribute('type', 'password');
      span.innerHTML = '<i class="fa fa-eye-slash"></i>';
    }
  }
}
